export const checkEnvironment = () => window.envConfig || {};
